import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  page ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/reconcilation/page`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

};
